export default __webpack_public_path__ + "static/media/girlIcon.c97da130.png";